(function () {
    if (window.productGalleryCompactExperimentInitialized) {
        return;
    }

    window.productGalleryCompactExperimentInitialized = true;
    window.galleryThumbnailGuardInitialized = true;
    document.documentElement.setAttribute('data-product-gallery-experiment', 'compact');

    var resizeTimer;

    function moveTitlePriceAndDetails(productView) {
        if (productView.classList.contains('productView-compact-experiment')) {
            return;
        }

        var productTop = productView.querySelector('.productView-top');
        var productDetails = productView.querySelector('.halo-productView-right');
        var productContent = productView.querySelector('.productView-product');
        var productTitle = productView.querySelector('.productView-title');
        var productPrice = productView.querySelector('.productView-price');
        var priceBlock = productPrice ? productPrice.parentElement : null;

        if (!productTop || !productDetails || !productContent || !productTitle || !priceBlock) {
            return;
        }

        var titleColumn = document.createElement('div');
        var priceColumn = document.createElement('div');
        var titleContent = productTitle.parentElement;

        titleColumn.className = 'productView-experiment-title';
        priceColumn.className = 'productView-experiment-price';

        productContent.querySelectorAll(':scope > .discount-text').forEach(function (discount) {
            titleColumn.appendChild(discount);
        });

        titleContent.classList.add('productView-experiment-title-content');
        titleColumn.appendChild(titleContent);

        var reviewBadge = productContent.querySelector(':scope > .jdgm-preview-badge');

        if (reviewBadge) {
            titleColumn.appendChild(reviewBadge);
        }

        priceColumn.appendChild(priceBlock);
        productView.insertBefore(titleColumn, productTop);
        productView.insertBefore(priceColumn, productTop);
        productView.appendChild(productDetails);
        productView.classList.add('productView-compact-experiment');
    }

    function initializeQuantitySelector(productView) {
        var quantityInput = Array.prototype.find.call(
            productView.querySelectorAll('.productView-product input[name="quantity"]'),
            function (input) {
                return input.type === 'number' && input.closest('.pvGroup-row');
            }
        );

        if (!quantityInput) {
            return;
        }

        var quantityGroup = quantityInput.closest('quantity-input.productView-quantity');
        var quantityContainer = quantityInput.closest('.quantity__container');
        var quantityRow = quantityInput.closest('.pvGroup-row');
        var quantityLabel = quantityGroup ? quantityGroup.querySelector('.quantity__label') : null;

        if (
            !quantityGroup ||
            !quantityContainer ||
            !quantityRow ||
            quantityGroup.hasAttribute('data-quantity-dropdown-enhanced')
        ) {
            return;
        }

        var quantitySelect = document.createElement('select');
        var customQuantityInput = document.createElement('input');
        var quantityValue = document.createElement('span');
        var quantityArrow = document.createElement('span');
        var currentQuantity = parseInt(quantityInput.value, 10) || 1;
        var labelText = quantityLabel ? quantityLabel.textContent.trim() : '';

        quantitySelect.className = 'quantity-dropdown-enhanced__select';
        quantitySelect.id = quantityInput.id + '-select';
        quantitySelect.setAttribute('aria-label', labelText);

        quantityValue.className = 'quantity-dropdown-enhanced__value';
        quantityValue.textContent = String(Math.min(9, currentQuantity));
        quantityValue.setAttribute('aria-hidden', 'true');

        quantityArrow.className = 'quantity-dropdown-enhanced__arrow';
        quantityArrow.setAttribute('aria-hidden', 'true');

        for (var quantity = 1; quantity <= 9; quantity += 1) {
            var option = document.createElement('option');

            option.value = String(quantity);
            option.textContent = String(quantity);
            quantitySelect.appendChild(option);
        }

        var extendedOption = document.createElement('option');

        extendedOption.value = '10-plus';
        extendedOption.textContent = '10+';
        quantitySelect.appendChild(extendedOption);

        customQuantityInput.type = 'number';
        customQuantityInput.className = 'quantity-dropdown-enhanced__number';
        customQuantityInput.id = quantityInput.id + '-custom';
        customQuantityInput.min = '1';
        customQuantityInput.step = '1';
        customQuantityInput.inputMode = 'numeric';
        customQuantityInput.value = String(Math.max(10, currentQuantity));
        customQuantityInput.setAttribute('aria-label', labelText);

        quantityInput.classList.add('quantity-dropdown-enhanced__source', 'is-hidden');

        if (currentQuantity >= 10) {
            quantitySelect.value = '10-plus';
            quantitySelect.classList.add('is-hidden');
            quantityGroup.classList.add('quantity-dropdown-show-custom');
        } else {
            quantitySelect.value = String(currentQuantity);
            customQuantityInput.classList.add('is-hidden');
        }

        quantitySelect.addEventListener('change', function () {
            if (quantitySelect.value === '10-plus') {
                quantityInput.value = '10';
                customQuantityInput.value = '10';
                quantitySelect.classList.add('is-hidden');
                customQuantityInput.classList.remove('is-hidden');
                quantityGroup.classList.add('quantity-dropdown-show-custom');

                if (quantityLabel) {
                    quantityLabel.htmlFor = customQuantityInput.id;
                }

                window.requestAnimationFrame(function () {
                    customQuantityInput.focus();
                    customQuantityInput.select();
                });
                return;
            }

            quantityInput.value = quantitySelect.value;
            quantityValue.textContent = quantitySelect.value;
        });

        customQuantityInput.addEventListener('input', function () {
            quantityInput.value = customQuantityInput.value;
        });

        customQuantityInput.addEventListener('change', function () {
            quantityInput.value = customQuantityInput.value;
        });

        customQuantityInput.addEventListener('blur', function () {
            var parsedQuantity = parseInt(customQuantityInput.value, 10);

            if (!parsedQuantity || parsedQuantity < 1) {
                customQuantityInput.value = '1';
            }

            quantityInput.value = customQuantityInput.value;
        });

        quantityContainer.insertBefore(quantityValue, quantityInput);
        quantityContainer.insertBefore(quantitySelect, quantityInput);
        quantityContainer.insertBefore(customQuantityInput, quantityInput);
        quantityContainer.insertBefore(quantityArrow, quantityInput);
        quantityGroup.setAttribute('data-quantity-dropdown-enhanced', 'true');
        quantityGroup.classList.add('quantity-dropdown-enhanced');
        quantityRow.classList.add('quantity-dropdown-row');

        if (quantityLabel && currentQuantity < 10) {
            quantityLabel.htmlFor = quantitySelect.id;
        }
    }

    // ---------------------------------------------------------------------
    // Responsive deal-style price
    //
    // The theme prints the price as one string ('AED 50,700'), so the
    // currency, whole and fraction parts have to be split apart here before
    // CSS can size them independently. Only runs when a compare-at price is
    // present; the block is built once and the same presentation is used at every
    // viewport, which keeps it resize-safe with no JS teardown.
    // ---------------------------------------------------------------------

    function escapeHtml(value) {
        return String(value).replace(/[&<>"']/g, function (character) {
            return {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#39;'
            }[character];
        });
    }

    function parseMoneyText(text) {
        var trimmed = (text || '').replace(/\s+/g, ' ').trim();
        var match = trimmed.match(/^(\D*?)\s*([\d.,]+)\s*(\D*)$/);

        if (!match) {
            return null;
        }

        var raw = match[2];
        var currency = (match[1] || match[3] || '').trim();
        var whole = raw;
        var fraction = '00';
        var decimalMatch = raw.match(/^(.*)\.(\d{1,2})$/);

        if (decimalMatch) {
            whole = decimalMatch[1];
            fraction = (decimalMatch[2] + '0').slice(0, 2);
        }

        var value = parseFloat(raw.replace(/,/g, ''));

        if (!isFinite(value) || value <= 0) {
            return null;
        }

        return {
            currency: currency,
            whole: whole,
            fraction: fraction,
            value: value,
            text: trimmed
        };
    }

    function renderDealPrice(productView) {
        var priceColumn = productView.querySelector('.productView-experiment-price');

        if (!priceColumn) {
            return;
        }

        var existing = priceColumn.querySelector(':scope > .pg-deal-price');
        var compareElement = priceColumn.querySelector('.price__compare .money');
        var saleElement = priceColumn.querySelector('.price__sale .price-item--sale .money');

        var compare = compareElement ? parseMoneyText(compareElement.textContent) : null;
        var sale = saleElement ? parseMoneyText(saleElement.textContent) : null;

        // No compare-at price (or it is not actually higher) - leave the
        // theme's own price markup alone on every screen size.
        if (!compare || !sale || compare.value <= sale.value) {
            if (existing) {
                existing.remove();
            }

            priceColumn.classList.remove('has-deal-price');
            return;
        }

        var percent = Math.round((1 - sale.value / compare.value) * 100);
        var signature = percent + '|' + sale.text + '|' + compare.text;

        priceColumn.classList.add('has-deal-price');

        if (existing && existing.getAttribute('data-signature') === signature) {
            return;
        }

        if (existing) {
            existing.remove();
        }

        var block = document.createElement('div');

        block.className = 'pg-deal-price';
        block.setAttribute('data-signature', signature);
        block.innerHTML =
            '<div class="pg-deal-price__row">' +
                '<span class="pg-deal-price__discount">-' + percent + '%</span>' +
                '<span class="pg-deal-price__amount">' +
                    '<span class="pg-deal-price__currency">' + escapeHtml(sale.currency) + '</span>' +
                    '<span class="pg-deal-price__whole">' + escapeHtml(sale.whole) + '</span>' +
                    '<span class="pg-deal-price__fraction">' + escapeHtml(sale.fraction) + '</span>' +
                '</span>' +
            '</div>' +
            '<div class="pg-deal-price__list">List Price: <s>' + escapeHtml(compare.text) + '</s></div>';

        priceColumn.appendChild(block);
    }

    function watchPriceColumn(productView) {
        var priceColumn = productView.querySelector('.productView-experiment-price');

        if (!priceColumn) {
            return;
        }

        if (!productView._compactPriceObserver && window.MutationObserver) {
            var rebuilding = false;
            var observer = new MutationObserver(function (mutations) {
                if (rebuilding) {
                    return;
                }

                // Ignore the mutations caused by our own block being written.
                var fromTheme = mutations.some(function (mutation) {
                    var node = mutation.target;
                    var element = node.nodeType === 1 ? node : node.parentElement;

                    return !element || !element.closest('.pg-deal-price');
                });

                if (!fromTheme) {
                    return;
                }

                rebuilding = true;
                renderDealPrice(productView);
                window.setTimeout(function () {
                    rebuilding = false;
                }, 0);
            });

            observer.observe(priceColumn, { childList: true, subtree: true, characterData: true });
            productView._compactPriceObserver = observer;
        }

        renderDealPrice(productView);
    }

    function markGalleryReady(productView) {
        var galleryWrapper = productView.querySelector('.productView-images-wrapper');

        if (!galleryWrapper || galleryWrapper.classList.contains('is-gallery-ready-v3')) {
            return;
        }

        window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
                galleryWrapper.classList.add('is-gallery-ready-v3');
            });
        });
    }

    function animateThumbnailRail(thumbnailGallery, nextPosition, isHorizontal) {
        var currentPosition = isHorizontal ? thumbnailGallery.scrollLeft : thumbnailGallery.scrollTop;
        var distance = nextPosition - currentPosition;

        if (thumbnailGallery._compactRailAnimationFrame) {
            window.cancelAnimationFrame(thumbnailGallery._compactRailAnimationFrame);
            thumbnailGallery._compactRailAnimationFrame = null;
        }

        if (Math.abs(distance) < 1) {
            return;
        }

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            if (isHorizontal) {
                thumbnailGallery.scrollLeft = nextPosition;
            } else {
                thumbnailGallery.scrollTop = nextPosition;
            }
            return;
        }

        var startTime = null;
        var duration = Math.min(300, Math.max(210, Math.abs(distance) * 1.4));

        thumbnailGallery.classList.add('is-animating-thumbnail-rail');

        function step(timestamp) {
            if (startTime === null) {
                startTime = timestamp;
            }

            var progress = Math.min(1, (timestamp - startTime) / duration);
            var eased = 1 - Math.pow(1 - progress, 3);
            var position = currentPosition + distance * eased;

            if (isHorizontal) {
                thumbnailGallery.scrollLeft = position;
            } else {
                thumbnailGallery.scrollTop = position;
            }

            if (progress < 1) {
                thumbnailGallery._compactRailAnimationFrame = window.requestAnimationFrame(step);
            } else {
                thumbnailGallery._compactRailAnimationFrame = null;
                thumbnailGallery.classList.remove('is-animating-thumbnail-rail');
            }
        }

        thumbnailGallery._compactRailAnimationFrame = window.requestAnimationFrame(step);
    }

    function positionActiveThumbnailIndicator(thumbnailGallery, activeThumbnail) {
        var indicator = thumbnailGallery.querySelector(':scope > .product-gallery-active-indicator-v4');
        var axis = window.matchMedia('(max-width: 767px)').matches ? 'horizontal' : 'vertical';
        var isNew = !indicator;
        var axisChanged;

        if (!indicator) {
            indicator = document.createElement('span');
            indicator.className = 'product-gallery-active-indicator-v4 is-positioning';
            indicator.setAttribute('aria-hidden', 'true');
            thumbnailGallery.appendChild(indicator);
        }

        axisChanged = indicator.getAttribute('data-axis') &&
            indicator.getAttribute('data-axis') !== axis;

        if (axisChanged) {
            indicator.classList.add('is-positioning');
        }

        indicator.setAttribute('data-axis', axis);
        indicator.style.width = activeThumbnail.offsetWidth + 'px';
        indicator.style.height = activeThumbnail.offsetHeight + 'px';
        indicator.style.transform =
            'translate3d(' + activeThumbnail.offsetLeft + 'px, ' +
            activeThumbnail.offsetTop + 'px, 0)';

        if (isNew || axisChanged) {
            window.requestAnimationFrame(function () {
                window.requestAnimationFrame(function () {
                    indicator.classList.remove('is-positioning');
                    indicator.classList.add('is-ready');
                });
            });
        } else {
            indicator.classList.add('is-ready');
        }
    }

    function setActiveThumbnail(thumbnailGallery, index) {
        var thumbnails = thumbnailGallery.querySelectorAll('.productView-thumbnail');

        thumbnails.forEach(function (thumbnail, thumbnailIndex) {
            var isActive = thumbnailIndex === index;
            var link = thumbnail.querySelector('.productView-thumbnail-link');

            thumbnail.classList.toggle('is-active', isActive);

            if (link) {
                if (isActive) {
                    link.setAttribute('aria-current', 'true');
                } else {
                    link.removeAttribute('aria-current');
                }
            }
        });

        var activeThumbnail = thumbnails[index];
        var lastThumbnail = thumbnails[thumbnails.length - 1];

        if (!activeThumbnail || !lastThumbnail) {
            return;
        }

        positionActiveThumbnailIndicator(thumbnailGallery, activeThumbnail);

        var isHorizontal = window.matchMedia('(max-width: 767px)').matches;
        var railSize = isHorizontal ? thumbnailGallery.clientWidth : thumbnailGallery.clientHeight;
        var itemStart = isHorizontal ? activeThumbnail.offsetLeft : activeThumbnail.offsetTop;
        var contentEnd = isHorizontal
            ? lastThumbnail.offsetLeft + lastThumbnail.offsetWidth
            : lastThumbnail.offsetTop + lastThumbnail.offsetHeight;
        var nextPosition = Math.max(0, Math.min(itemStart, Math.max(0, contentEnd - railSize)));

        animateThumbnailRail(thumbnailGallery, nextPosition, isHorizontal);
    }

    function positionProductGallery(productView) {
        var jquery = window.jQuery;

        if (!jquery || !jquery.fn || !jquery.fn.slick) {
            return;
        }

        var mainGallery = productView.querySelector('.productView-nav');
        var thumbnailGallery = productView.querySelector('.productView-for:not(.mobile)');

        if (!mainGallery || !mainGallery.classList.contains('slick-initialized')) {
            return;
        }

        var mainSlider = jquery(mainGallery);
        var currentIndex = mainSlider.slick('slickCurrentSlide');
        mainSlider.slick('setPosition');

        if (thumbnailGallery) {
            setActiveThumbnail(thumbnailGallery, currentIndex);
        }
    }

    function scheduleGalleryPosition(productView) {
        if (productView._compactGalleryAnimationFrame) {
            window.cancelAnimationFrame(productView._compactGalleryAnimationFrame);
        }

        productView._compactGalleryAnimationFrame = window.requestAnimationFrame(function () {
            productView._compactGalleryAnimationFrame = null;
            positionProductGallery(productView);
        });
    }

    function initializeStableThumbnailRail(productView) {
        var jquery = window.jQuery;

        if (!jquery || !jquery.fn || !jquery.fn.slick) {
            return;
        }

        var mainGallery = productView.querySelector('.productView-nav');
        var thumbnailGallery = productView.querySelector('.productView-for:not(.mobile)');

        if (!mainGallery || !mainGallery.classList.contains('slick-initialized')) {
            return;
        }

        if (!thumbnailGallery) {
            markGalleryReady(productView);
            return;
        }

        var mainSlider = jquery(mainGallery);
        var thumbnailSlider = jquery(thumbnailGallery);

        if (
            productView._compactGalleryMain === mainGallery &&
            productView._compactGalleryThumbnails === thumbnailGallery
        ) {
            if (thumbnailGallery.classList.contains('slick-initialized')) {
                thumbnailSlider.slick('unslick');
            }

            scheduleGalleryPosition(productView);
            markGalleryReady(productView);
            return;
        }

        if (productView._compactGalleryResizeObserver) {
            productView._compactGalleryResizeObserver.disconnect();
        }

        productView._compactGalleryMain = mainGallery;
        productView._compactGalleryThumbnails = thumbnailGallery;
        thumbnailGallery.setAttribute('data-stable-thumbnail-rail', 'true');

        mainSlider.slick('slickSetOption', 'asNavFor', null, false);

        if (thumbnailGallery.classList.contains('slick-initialized')) {
            thumbnailSlider.slick('unslick');
        }

        thumbnailGallery.querySelectorAll('.productView-thumbnail').forEach(function (thumbnail, index) {
            thumbnail.setAttribute('data-gallery-index', index);
        });

        thumbnailGallery.addEventListener('click', function (event) {
            var thumbnail = event.target.closest('.productView-thumbnail');

            if (!thumbnail || !thumbnailGallery.contains(thumbnail)) {
                return;
            }

            event.preventDefault();
            mainSlider.slick('slickGoTo', Number(thumbnail.getAttribute('data-gallery-index')) || 0);
        });

        mainSlider
            .off('beforeChange.productGalleryCompactExperiment afterChange.productGalleryCompactExperiment')
            .on('beforeChange.productGalleryCompactExperiment', function (event, slick, currentSlide, nextSlide) {
                setActiveThumbnail(thumbnailGallery, nextSlide);
            })
            .on('afterChange.productGalleryCompactExperiment', function (event, slick, currentSlide) {
                setActiveThumbnail(thumbnailGallery, currentSlide);
            });

        mainGallery.querySelectorAll('img').forEach(function (image) {
            if (!image.complete) {
                image.addEventListener('load', function () {
                    scheduleGalleryPosition(productView);
                }, { once: true });
            }
        });

        if (window.ResizeObserver) {
            productView._compactGalleryResizeObserver = new ResizeObserver(function () {
                scheduleGalleryPosition(productView);
            });
            productView._compactGalleryResizeObserver.observe(mainGallery);
        }

        scheduleGalleryPosition(productView);
        markGalleryReady(productView);
    }

    function initializeProductViews() {
        var jquery = window.jQuery;

        if (!jquery || !jquery.fn || !jquery.fn.slick) {
            window.setTimeout(initializeProductViews, 200);
            return;
        }

        document.querySelectorAll('.productView').forEach(function (productView) {
            moveTitlePriceAndDetails(productView);
            initializeQuantitySelector(productView);
            watchPriceColumn(productView);
            initializeStableThumbnailRail(productView);
        });
    }

    function handleResize() {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
            document.querySelectorAll('.productView').forEach(scheduleGalleryPosition);
        }, 160);
    }

    window.addEventListener('resize', handleResize, { passive: true });
    document.addEventListener('shopify:section:load', initializeProductViews);

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeProductViews, { once: true });
    } else {
        initializeProductViews();
    }

    window.setTimeout(initializeProductViews, 500);
    window.setTimeout(initializeProductViews, 1500);
    window.setTimeout(initializeProductViews, 3000);
})();
